import PubSub from "./pubsub.js";

if (!customElements.get("sticky-nav")) {
  class StickyNav extends HTMLElement {
    constructor() {
      super();

      this.pubsub = PubSub;

      this.sticky = this.querySelectorAll(".sticky-nav");
      this.main = document.querySelector("#main");
    }

    handleScroll = (e) => {
      this.sticky.forEach((el) => {
        el.classList.toggle("is--sticky", window.scrollY > 126);
      });

      // this.sticky.classList.toggle("is--sticky", window.scrollY > 30);

      this.main.classList.toggle(
        "is--influenced-by-sticky",
        window.scrollY > 126
      );

      if (window.scrollY > 126) {
        this.pubsub.pub("mobile-menu:is--sticky", { isSticky: true });
      } else {
        this.pubsub.pub("mobile-menu:is--sticky", { isSticky: false });
      }
    };

    connectedCallback() {
      window.addEventListener("scroll", this.handleScroll.bind(this));
    }
    disconnectedCallback() {}
  }

  customElements.define("sticky-nav", StickyNav);
}
